import { render } from "./DataSourceTreeSelect.vue?vue&type=template&id=6fca0a5f&scoped=true"
import script from "./DataSourceTreeSelect.vue?vue&type=script&lang=ts"
export * from "./DataSourceTreeSelect.vue?vue&type=script&lang=ts"

import "./DataSourceTreeSelect.vue?vue&type=style&index=0&id=6fca0a5f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fca0a5f"

export default script